<template>
  <v-menu
    ref="menu"
    v-model="dateMenu"
    :close-on-content-click="false"
    transition="scale-transition"
    offset-y
    max-width="290px"
    min-width="auto"
  >
    <template v-slot:activator="{ on }">
      <v-text-field
        :value="dateDisp"
        :label="label"
        :placeholder="label"
        :outlined="outlined"
        append-icon="mdi-calendar"
        hide-details
        readonly
        v-on="on"
        clearable
        @click:clear="removeYearMonthFilter"
        class="shrink"
      >
        <!-- <template slot="prepend-inner">
          <slot name="closed"/>
        </template> -->
        <!-- <template slot="prepend-inner">
          <v-btn
            icon
            @click="removeYearMonthFilter"
            small
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </template> -->
      </v-text-field>
    </template>
    <v-date-picker
      v-model="dateVal"
      type="month"
      v-on:input="handleInput($event)"
      no-title
      scrollable
      @input="dateMenu = false"
    />
  </v-menu>
</template>
<script>
  export default {
    name: 'CustomDatePicker',
    props: {
      value: {
        type: String,
        default: ''
      },
      label: {
        type: String,
        default: 'Ngày'
      },
      outlined: {
        type: Boolean,
        default: false
      },
      hideDetails: {
        type: Boolean,
        default: false
      }
    },
    data () {
      return {
        dateMenu: false,
        dateVal: null
      }
    },
    computed: {
      dateDisp: {
        get () {
          if(this.dateVal)
            return this.parseDate(this.dateVal);
          return this.$props.value;
        },
        set (value) {
          this.$emit('change', value);
        }
      }
    },
    methods: {
      parseDate (date) {
        if (!date) { return null };
        const [year, month] = date.split('-');
        return `${month.padStart(2, '0')}/${year}`;
      },
      handleInput(content) {
        this.$emit("input", this.parseDate(content) );
      },
      removeYearMonthFilter() {
        this.$emit("input", null);
      }
    }
  }
</script>